import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { user } = await exchangeSession(session_id);
        setUser(user);
        window.history.replaceState(null, "", "/journey");
        navigate("/journey", { replace: true, state: { user } });
      } catch (err) {
        const reason =
          err?.response?.status === 403
            ? err?.response?.data?.detail || "Access not authorized."
            : null;
        navigate("/login", { replace: true, state: { denied: reason } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-zinc-400 font-mono text-sm">
      <span className="mr-2">[recon]</span>
      <span>establishing secure channel</span>
      <span className="blink ml-1">_</span>
    </div>
  );
}
